import { render, staticRenderFns } from "./Depoimentos.vue?vue&type=template&id=2f583808&scoped=true&"
import script from "./Depoimentos.vue?vue&type=script&lang=js&"
export * from "./Depoimentos.vue?vue&type=script&lang=js&"
import style0 from "./Depoimentos.vue?vue&type=style&index=0&id=2f583808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f583808",
  null
  
)

export default component.exports